import React from 'react'
import { NFTtransferItem } from './NFTtransferItem'
import { Transaction } from '../../../app/models/generated'
import styles from '../BlocksPage/index.module.sass'
interface TransactionArrayInterface {
    TransactionArray: Array<Transaction>
}

export const NFTtransferItems = ({
    TransactionArray,
}: TransactionArrayInterface) => {
    return (
        <tbody className={styles.tableBody}>
            {TransactionArray.map((transaction: Transaction) => {
                return (
                    <NFTtransferItem
                        key={transaction.hash}
                        transaction={transaction}
                    />
                )
            })}
        </tbody>
    )
}
